// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"ffcf2aea","79":"e95b8d3d","147":"db11a616","189":"e0a031ac","328":"21634b69","421":"453980b8","453":"1f9ba415","689":"9de5588d","691":"f4531f20","724":"83e8f629","787":"44ffcfd7","800":"162210ed","999":"8c7f3a75"}[chunkId] + ".chunk.js";
};